import './main.less';

import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from './';

import PayoutSettingsForm from './payout-settings-form/main';

export default connect(mapStateToProps, mapDispatchToProps)(PayoutSettingsForm);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/main.js